import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIHoverActionController} from './UIHoverActionController'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {CardEnum, TileCornerBuildingType} from '@colonist/game-states'
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'
import {GameStateEnums} from '../../../../../shared/GameEnums'

export class UIKnightActivationHoverActionController extends UIHoverActionController {
    private readonly knightPlayerValidator: MechanicValidatorKnightPlayer

    constructor(uiGameManager: UIGameManager, knightPlayerValidator: MechanicValidatorKnightPlayer) {
        super(uiGameManager)
        this.isCornerAction = true
        this.resources = [CardEnum.Grain]
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmActivateKnightSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)

        this.knightPlayerValidator = knightPlayerValidator
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums): void {
        super.onEvent(data, eventType)

        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.KnightStateUpdated: this.updateState(); break
            default: break
        }
    }

    protected updateState() {
        const action = this.knightPlayerValidator.canPlayerActivateKnight()
        this.updateHoverLocations(action.validHoverLocations, action.canTakeAction)
    }

    getTexture(locationCornerIndex: number): PIXI.Texture {
        const knightAtLocation = this.knightPlayerValidator.getKnightAtLocation(locationCornerIndex)
        if(knightAtLocation === undefined) return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, TileCornerBuildingType.KnightInactiveLevel1)

        const knightTexture = TileCornerBuildingType[`KnightActiveLevel${knightAtLocation.level}`]
        return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, knightTexture)
    }

    // eslint-disable-next-line class-methods-use-this
    protected getBankActionAmount(index: number): number | undefined {
        return undefined
    }
}
